import { OnInit } from '@angular/core';
import { MaintenanceModeConfig } from '../model/maintenance-config/maintenance-mode-config';
import { DateUtil } from '../shared/utils/Date/date-util';
import { TranslateService } from '@ngx-translate/core';
import { KeyDirections } from '../shared/key-directions.enum';
import { LanguageService } from '../services/language/language.service';
var MaintenancePageComponent = /** @class */ (function () {
    function MaintenancePageComponent(translateService, languageService) {
        this.translateService = translateService;
        this.languageService = languageService;
    }
    MaintenancePageComponent.prototype.ngOnInit = function () {
        this.inMaintenance = this.maintenanceModeConfig.isActive();
        this.endDayName = DateUtil.getNameOfDay(this.maintenanceModeConfig.endDate, this.languageService.getCurrentLanguage());
        this.endDayHour = this.maintenanceModeConfig.endDate.getHours() + '';
        this.endDayMinutes = this.maintenanceModeConfig.endDate.getMinutes() + '';
    };
    MaintenancePageComponent.prototype.keyEvent = function (event) {
        if (event.keyCode === KeyDirections.ESCAPE) {
            window.close();
        }
    };
    return MaintenancePageComponent;
}());
export { MaintenancePageComponent };
